import styled from 'styled-components';
import Button from '../../../../../../components/Button';

export const ProductImage = styled.img`
  width: 150px;
  height: 150px;
`;

export const Field = styled.div`
  padding: 1rem 0;
`;

export const Select = styled.select`
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
`;

export const SaveCopyButton = styled(Button)`
  margin-left: 15px;
`;

export const ProductButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
